import { SmallLayout } from "../../layouts";
import { OverheidHeaderOrganism, OverOrganism, ToastOrganism } from "../../organisms";

export default function OverScreen() {
  return (
    <SmallLayout
      header={
        <>
          <ToastOrganism />
          <OverheidHeaderOrganism />
        </>
      }
      body={<OverOrganism />}
    />
  );
}
